<pcs-traffic-lights-list [trafficLights]="data"></pcs-traffic-lights-list>
